import $ from 'jquery';

const home = {
    /**
     * Init methods
     */
    init: function () {
        this.readMore();
    },

    /**
     * Read more/less button for home page
     * **/
    readMore: function () {
        const $readMoreDesc = $('#read-more-desc');
        const $eventDescMore = $('#more-desc');
        const $eventDescLess = $('#less-desc');

        $eventDescLess.css({'display': 'none'});

        $readMoreDesc.click(function(event) {
            event.preventDefault();

            $eventDescMore.css({ 'display': 'inline' });
            $eventDescLess.css({ 'display': 'inline' });
            $readMoreDesc.css({ 'display': 'none' });
        });

        $eventDescLess.click(function(event) {
            event.preventDefault();
            $eventDescMore.css({
                'display': 'none'
            });
            $eventDescLess.css({
                'display': 'none'
            });
            $readMoreDesc.css({
                'display': 'inline'
            });
        });
    }
};

export default home;
